import React from 'react';
import { CircleCheck, ShieldCheck, CircleDollarSign } from 'lucide-react';
import AnimateInView from '@/components/ui/animate-in-view';
interface DifferentiatorProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}
const differentiators: DifferentiatorProps[] = [{
  icon: <ShieldCheck className="h-8 w-8 text-forti-fi" />,
  title: "Unparalleled Discretion",
  description: "Our security solutions blend seamlessly with your property, ensuring the highest level of protection without compromising aesthetics or announcing their presence."
}, {
  icon: <CircleDollarSign className="h-8 w-8 text-forti-fi-teal" />,
  title: "Investment Protection",
  description: "Beyond security, our systems protect the value of your assets and investments, offering a tangible return by mitigating risks that could impact your property's worth."
}, {
  icon: <CircleCheck className="h-8 w-8 text-gold" />,
  title: "Proactive Intelligence",
  description: "Our AI-driven systems don't just alert after a breach. They predict and prevent incidents, distinguishing between actual threats and false alarms with remarkable precision."
}];

/**
 * @component TheFortiFiDifference
 * @description Component highlighting key differentiators of Forti-Fi's premium security solutions
 * @returns {JSX.Element} A section with 3-column layout highlighting key differentiators
 */
const TheFortiFiDifference: React.FC = () => {
  return <section aria-labelledby="difference-heading" className="section bg-forti-fi-background px-[14px] my-[3px] py-[83px]">
      <div className="container mx-auto">
        <AnimateInView animation="fade-in">
          <div className="text-center mb-16">
            <div className="inline-block mb-4">
              <div className="gold-divider mx-auto"></div>
            </div>
            <h2 id="difference-heading" className="text-3xl md:text-4xl tracking-tight text-forti-fi mb-6">
              The Forti-Fi Difference
            </h2>
            <p className="text-center max-w-2xl mx-auto mb-12 text-forti-fi-charcoal">
              What sets our security solutions apart for properties of distinction
            </p>
          </div>
        </AnimateInView>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {differentiators.map((diff, index) => <AnimateInView key={diff.title} animation="slide-up" delay={index * 100} className="flex flex-col items-center text-center p-8 rounded-lg bg-white/60 backdrop-blur-sm border border-gold/10 shadow-premium hover-lift">
              <div className="mb-6 p-4 rounded-full bg-forti-fi-background/60">
                {diff.icon}
              </div>
              <h3 className="text-xl font-serif text-forti-fi-dark mb-4">{diff.title}</h3>
              <p className="text-forti-fi-charcoal">{diff.description}</p>
            </AnimateInView>)}
        </div>
      </div>
    </section>;
};
export default TheFortiFiDifference;